import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
	template: `
    <div class="container">
        <div class="jumbotron">
            <h1 class="display-3">You have been logged out</h1>
            <p class="lead">You have been successfully logged out. You will be automatically redirected to the main page.</p>
            <hr class="my-4">
            <p>If you have noot been redirected automatically, please press on the Home button.</p>
            <p class="lead">
            <a class="btn btn-info btn-lg" href="#" role="button">Home</a>
            </p>
        </div>
    </div>`
})

export class LogOutComponent implements OnInit {
	constructor(private router: Router) { }

	ngOnInit() {
		setTimeout(() => {
			this.router.navigate(['login']);
		}, 3000);
	}
}
